import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { ProvisioningTaskStatus } from '@/types/provisioning';

const TASK_STATUS_STYLES: Record<ProvisioningTaskStatus, { label: string; className: string }> = {
  queued: { label: 'Queued', className: 'bg-slate-100 text-slate-700 border-slate-200' },
  running: { label: 'Running', className: 'bg-blue-100 text-blue-800 border-blue-200' },
  success: { label: 'Success', className: 'bg-emerald-100 text-emerald-800 border-emerald-200' },
  failed: { label: 'Failed', className: 'bg-red-100 text-red-800 border-red-200' },
  stopped: { label: 'Stopped', className: 'bg-amber-100 text-amber-900 border-amber-200' },
};

export function TaskStatusBadge({
  status,
  className,
}: {
  status: ProvisioningTaskStatus;
  className?: string;
}): JSX.Element {
  const style = TASK_STATUS_STYLES[status] ?? {
    label: status,
    className: 'bg-slate-100 text-slate-600 border-slate-200',
  };

  return (
    <Badge variant="outline" className={cn('border', style.className, className)}>
      {style.label}
    </Badge>
  );
}
